import { ErrorSummary } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useOppvarmingFormContext } from '../../utils';
import { BioenergiErrorSummary } from '../bioenergi/bioenergiErrorSummary';
import { ElektrisitetErrorSummary } from '../elektrisitet/components/elektrisitetErrorSummary';
import { VedErrorSummary } from '../ved/components/vedErrorSummary';
import { GassErrorSummary } from '../gass/gassErrorSummary';
import { VarmepumpeErrorSummary } from '../varmepumpe/varmepumpeErrorSummary';
import { FjernvarmeErrorSummary } from '../fjernvarme/fjernvarmeErrorSummary';
import { SolfangerErrorSummary } from '../solfanger/solfangerErrorSummary';
import { OljeErrorSummary } from '../olje/oljeErrorSummary';
import { MissingRomoppvarmingWarning } from '../missingRomoppvarmingWarning';

import { ErrorSummaryHeader } from './styledComponents';
import { ErrorLinkItem } from './errorLinkItem';

export const FormErrors = () => {
  const { formState } = useOppvarmingFormContext();
  const { t } = useTranslation();

  if (Object.keys(formState.errors).length === 0) {
    return null;
  }

  // Root errors is used to display romoppvarming warning
  const { root, ...formErrors } = formState.errors;

  // Common validation for all the heating types - if none is selected.
  // All checkboxes share the same error message, we use the error from Elektrisitet.
  const selectionError = formErrors?.elektrisk?.selected;

  return (
    <>
      {Object.keys(formErrors).length > 0 && (
        <ErrorSummary role="alert" aria-live="assertive">
          <ErrorSummaryHeader>{t('form.errors.heading')}</ErrorSummaryHeader>

          {selectionError && (
            <ErrorSummary.List>
              <ErrorLinkItem error={selectionError} />
            </ErrorSummary.List>
          )}

          <ElektrisitetErrorSummary />
          <BioenergiErrorSummary />
          <VedErrorSummary />
          <GassErrorSummary />
          <OljeErrorSummary />
          <VarmepumpeErrorSummary />
          <FjernvarmeErrorSummary />
          <SolfangerErrorSummary />
        </ErrorSummary>
      )}

      {
        // If all selected oppvarming is used as "Tappevann", show warning
        root?.romoppvarmingMissing && <MissingRomoppvarmingWarning />
      }
    </>
  );
};
